//--------------------------------------------------------------------------------
export function timeSlotsToStr(v: number[] | undefined): string {
  if (!v?.length) return ''
  return v.join(', ')
}

//--------------------------------------------------------------------------------
export function strToTimeSlots(s: string): number[] {
  if (!s.trim()) return []
  return s.split(',').map((n) => parseInt(n.trim(), 10)).filter((n) => !Number.isNaN(n))
}

//--------------------------------------------------------------------------------
export function remoteAddressRangesToStr(v: string[] | undefined | null): string {
  if (!v?.length) return ''
  return v.join('\n')
}

//--------------------------------------------------------------------------------
export function strToRemoteAddressRanges(s: string): string[] | null {
  const list = s.split('\n').map((l) => l.trim()).filter(Boolean)
  return list.length ? list : null
}
